import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/PaintConfigurator/paintConfigurator.default"
    ).then((module) => ({ default: module.PaintConfiguratorDefault }))
);
